import { useState } from "react";
import { useNavigate } from "react-router-dom";
import type { FormEvent } from "react";
import { stats } from "@/mocks/site";
import { categories } from "@/mocks/leaks";

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const onSubmit = (event: FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/feed?q=${encodeURIComponent(value)}` : "/feed");
  };

  return (
    <section className="relative w-full overflow-hidden bg-secondary-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20crimson%20and%20amber%20light%20streaks%20with%20soft%20bokeh%20on%20a%20dark%20teal%20background%2C%20artistic%20editorial%20texture%2C%20cinematic%20moody%20gradient%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=kelou-hero-main&orientation=landscape"
          alt="蝌蚪爆料现场快讯主题背景"
          title="蝌蚪爆料最新现场快讯"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary-950/85 via-secondary-950/70 to-secondary-950/90" />
      </div>

      <div className="relative mx-auto w-full max-w-[1200px] px-4 py-16 md:px-8 md:py-24">
        <div className="flex w-full flex-col items-start">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/60 bg-primary-500/15 px-3 py-1.5 text-xs font-medium text-primary-100">
            <span className="flex h-4 w-4 items-center justify-center">
              <span className="h-2 w-2 rounded-full bg-primary-400 animate-live-dot" />
            </span>
            正在更新 · 今日已发布 6 条快讯
          </span>

          <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            蝌蚪爆料
            <span className="mt-2 block text-xl font-bold text-accent-300 md:text-3xl">
              最新现场 · 首发内幕 · 快讯抢先看
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-secondary-100/90 md:text-base">
            点开蝌蚪爆料，一手消息不间断。我们把散落各处的现场线索、首发内幕和热议话题，
            整理成能看懂来龙去脉的内容流，新鲜事每天更新，满足想第一时间掌握爆料动态的你。
          </p>

          <form
            onSubmit={onSubmit}
            role="search"
            className="mt-8 flex w-full max-w-xl items-center rounded-full border border-background-50/25 bg-background-50/10 p-1.5 backdrop-blur"
          >
            <span className="flex h-9 w-9 items-center justify-center text-background-50/80">
              <i className="ri-search-line text-lg" />
            </span>
            <input
              type="search"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="输入关键词，如 折叠屏、夜市、路演"
              aria-label="搜索爆料关键词"
              className="flex-1 bg-transparent px-2 text-sm text-background-50 outline-none placeholder:text-background-50/50"
            />
            <button
              type="submit"
              className="flex h-9 shrink-0 items-center rounded-full bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              搜爆料
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="text-xs text-secondary-200/80">热门搜索：</span>
            {categories.slice(0, 4).map((cat) => (
              <button
                key={cat.slug}
                type="button"
                onClick={() => navigate(`/topic/${cat.slug}`)}
                className="rounded-full border border-background-50/20 px-3 py-1 text-xs text-secondary-100 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        <dl className="mt-14 grid w-full grid-cols-2 gap-x-6 gap-y-8 border-t border-background-50/15 pt-8 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label}>
              <dt className="text-xs text-secondary-200/75">{item.label}</dt>
              <dd className="mt-2 font-heading text-2xl font-bold text-accent-300 md:text-3xl">
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}